import IBrandState from './interface/IBrandState'

export const initialState: IBrandState = {
  list: undefined,
  loading: false,
  columnMapping: undefined,
  fileSelected: undefined,
  statusProgress: undefined,
}
